import type { RecurringRevenueReport } from '@vy/types';
import { useMemo } from 'react';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import { useLabels } from '../../../../hooks/requests/use-labels';
import {
  buildContractStartDateFilterField,
  buildCountryFilterField,
  buildLabelsFilterField,
  buildLabelsOptions,
  buildPlanFilterField,
  buildStateFilterField,
  collectUniqueOptions,
  filterNonEmptySelectFields,
  useProductFilterField,
} from '../../reports-components/shared-filter-fields';

export function useNrrGrrReportFilterFields(report: RecurringRevenueReport): FilterField[] {
  const { data: labelsData } = useLabels();
  const productFilterField = useProductFilterField();

  return useMemo(() => {
    const countries = collectUniqueOptions(report.map((row) => row.country ?? null));
    const states = collectUniqueOptions(report.map((row) => row.state ?? null));
    const plans = collectUniqueOptions(report.map((row) => row.contractName ?? null));

    const presentLabelIds = new Set(
      report.flatMap((row) => (row.labels ?? []).map((label) => label.id)),
    );
    const labelOptions = buildLabelsOptions(labelsData?.labels, presentLabelIds);

    const allFields: FilterField[] = [
      buildCountryFilterField(countries),
      buildStateFilterField(states),
      buildLabelsFilterField(labelOptions),
      productFilterField,
      buildPlanFilterField(plans),
      buildContractStartDateFilterField(),
    ];

    return filterNonEmptySelectFields(allFields);
  }, [report, labelsData, productFilterField]);
}
